import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { OptimisationSchedule } from './optimisation-schedule'

@Injectable({
  providedIn: 'root',
})
export class OptimisationScheduleService extends RestClientPaged<OptimisationSchedule, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/optimisation/schedule', http, {
      idField: 'id',
    })
  }
}
